import { MDText } from 'i18n-react';

import { CrossCircleIcon, TickCircleIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import type { BasicPaginationMeta } from 'Components/Pagination/Pagination.types';
import type { DropdownMenuItemBase } from 'Storybook/peripheral/DropdownMenu/DropdownMenu.types';
import { AccountSlugs } from 'Types/account';
import type { StateSlug, TransportRequestedState } from 'Types/enquiryStates';
import { TransportRequestedValues } from 'Types/enquiryStates';
import type { VehicleAccountListItem } from 'Types/vehicle';
import { SOLD_CATEGORY, TRANSPORT_ALLOWED_STATES } from 'Utilities/vehicleState';

import LocalTexts from './PurchasesVehicleList/PurchasesVehicleList.texts';

export const isCompletedPage = (slug: unknown): boolean => slug === AccountSlugs.COMPLETE;

export const isCancelledPage = (slug: unknown): boolean => slug === AccountSlugs.CANCELLED;

export const isDidntWinPage = (slug: unknown): boolean => slug === AccountSlugs.DIDNT_WIN;

export const isActivePage = (slug: unknown): boolean => slug === AccountSlugs.ACTIVE;

export const isUnderOfferPage = (slug: unknown): boolean => slug === AccountSlugs.UNDER_OFFER;

const LocalT = new MDText(LocalTexts);

export const displayTransportRequestedTag = (
	slug?: StateSlug,
	transportRequested?: TransportRequestedState,
): boolean => {
	if (slug && transportRequested) {
		const isTransportAllowedState = TRANSPORT_ALLOWED_STATES.includes(slug);
		const isTransportRequested = transportRequested === TransportRequestedValues.REQUESTED;

		return isTransportAllowedState && isTransportRequested;
	}
	return false;
};

export const getVehicleState = (slug?: StateSlug): string => {
	const vehicleStateLabels = {
		[SOLD_CATEGORY.SOLD_CONFIRMED]: 'sold_confirmed',
		[SOLD_CATEGORY.SOLD_WAIT]: 'sold_wait',
		[SOLD_CATEGORY.SOLD_DOCUMENTS_REVIEWED]: 'checks_complete',
		[SOLD_CATEGORY.SOLD_INVOICE_PAID]: 'checks_complete',
		[SOLD_CATEGORY.SOLD]: 'checks_complete',
		[SOLD_CATEGORY.SOLD_INVOICE_RAISED]: 'checks_complete',
	};

	if (!slug) return 'fallback';

	return vehicleStateLabels[slug];
};

export const getPaginationMeta = (page: number, pageSize: number, total: number): BasicPaginationMeta => ({
	itemsPerPage: pageSize,
	pageNumber: page,
	pages: Math.ceil(total / pageSize),
	totalItemsCount: total,
});

export const getMarkAsDeliveredAttributes = ({
	id,
	isDelivered,
}: Pick<VehicleAccountListItem, 'isDelivered' | 'id'>): DropdownMenuItemBase => ({
	customIconProps: {
		filled: false,
	},
	cypressId: !isDelivered
		? cypressIds.buttons.purchasesCompleteMarkAsDelivered
		: cypressIds.buttons.purchasesCompleteUnmarkAsDelivered,
	icon: !isDelivered ? TickCircleIcon : CrossCircleIcon,
	id: !isDelivered ? `mark-as-delivered-${id}` : `unmark-as-delivered-${id}`,
	text: !isDelivered ? String(LocalT.translate('badges.mark')) : String(LocalT.translate('badges.unmark')),
});
